module.exports = __webpack_public_path__ + "static/media/1008550.2f96bf07.png";